import axios from "axios";
import config from "../config/config";
import store from "../store";
import Swal from 'sweetalert2';
import { i18n } from "../i18n";

const API_URL = config.API_URL; 

export const login = async (data) => {
    const email = data.email;
    const password = data.password;
    const response = await axios.post(`${API_URL}auth/login`, { email, password });
    return response.data;
};

export const revokeTokenSilently = async (token) => {
    try {
        if (token) {
            await axios.post(`${API_URL}auth/logout`, null, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
        }
    } catch (e) {
        // Ignore network/401 errors during token revocation
    } finally {
        if (axios.defaults && axios.defaults.headers && axios.defaults.headers.common) {
            delete axios.defaults.headers.common['Authorization'];
        }
        store.commit('setAuthToken', null);
        store.commit('setTokenType', null);
        store.commit('setUser', null);
    }
};

export const logout = async () => {
    const token = store.state.authToken || localStorage.getItem('authToken') || localStorage.getItem('token');
    await revokeTokenSilently(token);
    const isId = i18n.locale === 'id';
    Swal.fire({
        icon: 'success',
        title: i18n.t('auth.loggedOut') || (isId ? 'Berhasil Keluar' : 'Logged out'),
        text: i18n.t('auth.loggedOutDesc') || (isId ? 'Anda telah berhasil keluar dari akun.' : 'You have been logged out successfully.'),
        confirmButtonColor: '#0090e7',
    });
};

export const forgotPasswordAPI = async (email) => {
    const response = await axios.post(`${API_URL}auth/forgot-password`, { email, app: 'admin' });
    return response.data;
};

export const getProfile = async (id) => {
    try {
        const token = store.state.authToken;
        const response = await axios.get(`${API_URL}user/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching profile:', error);
        throw error;
    }
};

export const updateProfile = async (id, data) => {
    const token = store.state.authToken || localStorage.getItem('authToken') || localStorage.getItem('token') || '';
    let payload = data;
    if (!(data instanceof FormData)) {
        payload = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            if (key === 'profile_picture') {
                if (value instanceof File) {
                    payload.append('profile_picture', value);
                }
            } else if (value !== null && value !== undefined && typeof value !== 'object') {
                payload.append(key, value);
            }
        });
    }
    const response = await axios.post(`${API_URL}user/${id}`, payload, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
};


export const updateProfilePassword = async (id, data) => {
    const token = store.state.authToken;
    const response = await axios.post(`${API_URL}auth/change-password`, data, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
};